import angular from 'angular'
import templateUrl from './edit-event-host.component.html'

export const EditEventHostComponent = {
    templateUrl,
    controller: EditEventHostController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}


export const EditEventHostModal = {
    windowClass: 'xx-dialog pagespinner',
    component: "apexEditEventHost",
    controller: 'EditEventHostController',
    controllerAs: "vm",
    size: 'lg',
    backdrop: 'static',
}

function EditEventHostController($q, utilityService, divisionService, eventHostService) {
    'ngInject'

    const vm = this;
    vm.$onInit = $onInit;
    vm.divisionID;
    vm.eventHost;
    vm.handleCancel = handleCancel;
    vm.handleSave = handleSave;
    vm.hostTypes = [];
    vm.loaded = false;
    vm.onChangeRetailer = onChangeRetailer;
    vm.onChangeRetailerName = onChangeRetailerName;
    vm.retailers = [];
    vm.retailers;
    vm.stateProvinces = [];

    function $onInit() {
        const loadDivisions = divisionService.retrieveDivisions()
            .then(divisions => vm.divisions = divisions);

        utilityService.showLoadingUntilResolved(loadDivisions);

        vm.retailers = vm.resolve.retailers;
        vm.hostTypes = vm.resolve.hostTypes;
        vm.eventHost = vm.resolve.eventHost;
        vm.divisionID = vm.resolve.divisionID;
        mapEventHost(vm.eventHost);
        vm.pristineEventHost = angular.copy(vm.eventHost);
        vm.stateProvinces = vm.resolve.stateProvinces;
    }

    function mapEventHost(eventHost) {

        eventHost.Address = eventHost.Address ? eventHost.Address : {};
        eventHost.ContactPhone = eventHost.ContactPhone ? eventHost.ContactPhone : {};
        eventHost.Retailer = vm.retailers.filter(function (retailer) {
            return retailer.Id === eventHost.RetailerID
        })[0];
        eventHost.EventHostType = vm.hostTypes.filter(function (type) {
            return type.Name === eventHost.HostType
        })[0];
    }

    function handleSave() {
        utilityService.showLoading();
        (function () {
            const command = {
                DivisionID: vm.divisionID,
                HostName: vm.eventHost.HostName,
                HostLocationName: vm.eventHost.HostLocationName,
                HostNumber: vm.eventHost.HostNumber,
                EmailAddress: vm.eventHost.EmailAddress,
                Address: vm.eventHost.Address,
                ContactPhone: vm.eventHost.ContactPhone,
                HostType: vm.eventHost.EventHostType.Type,
                RetailerID: vm.eventHost.EventHostType.Type === "Retailer"
                    ? vm.eventHost.Retailer ? vm.eventHost.Retailer.Id : null : null,
                RetailerName: vm.eventHost.EventHostType.Type === "Retailer"
                    ? vm.eventHost.RetailerName : null
            };
            if (!vm.eventHost.EventHostID) {
                return eventHostService.createEventHost(command);
            } else {
                return eventHostService.updateEventHost(vm.eventHost.EventHostID, command);
            }
        })()
            .then(function (eventHost) {
                vm.close({ $value: eventHost });
            })
            .catch(function (ex) {
                alert("Saving event host failed: " + (ex.statusText || ex))
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function onChangeRetailer() {
        if (vm.eventHost.Retailer) {
            vm.eventHost.RetailerName = null;
            vm.eventHost.HostName = vm.eventHost.Retailer.Name;
        }
    }

    function onChangeRetailerName() {
        if (vm.eventHost.RetailerName) {
            vm.eventHost.Retailer = null;
            vm.eventHost.HostName = vm.eventHost.RetailerName;
        }
    }

    function handleCancel() {
        vm.dismiss({ $value: 'cancel' });
    }
}
